import { createFileRoute } from '@tanstack/react-router';

import { PlatformLayout } from '~/features/platform/components/platform-layout';
import { requireSystemAdmin } from '~/utils/guards';

export const Route = createFileRoute('/_authenticated/_tenant/platform')({
  beforeLoad: requireSystemAdmin(),
  component: () => <PlatformLayout />,
});
